import script from "./Add-New-Intermediary-Client.vue?vue&type=script&setup=true&lang=js"
export * from "./Add-New-Intermediary-Client.vue?vue&type=script&setup=true&lang=js"

import "./Add-New-Intermediary-Client.vue?vue&type=style&index=0&id=25d0dffe&lang=css"

const __exports__ = script;

export default __exports__